import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {ProductCollectionsEnum} from "../../../../shared/enums/product-collections.enum";
import {FieldAliases} from "../../../constants/fieldAliases";
import {CaCollectionFilterForm} from "../../../forms/ca-collection-filter.form";
import {CaCollectionParamsFilterModel} from "../../../models/search-params/filters/ca-collection-params-filter.model";
import {SuggestionsSearchModel} from "../../../models/suggestions-search.model";
import {CollectionSearchParamsFactoryService} from "../../../services/factories/collection-search-params-factory.service";
import {SuggestionsService} from "../../../services/suggestions.service";
import {CollectionFilterDirective} from "../collection-filter.directive";

@Component({
    selector: "pcg-ng-ca-collection-filter",
    template: require('./ca-collection-filter.component.html')
})
export class CaCollectionFilterComponent extends CollectionFilterDirective<CaCollectionFilterForm, CaCollectionParamsFilterModel> implements OnInit, OnDestroy {
    public KARYOTYPE_ALIAS: string = FieldAliases.CA_COLLECTION.KARYOTYPE;

    public constructor(
        formBuilder: FormBuilder,
        searchParamsFactory: CollectionSearchParamsFactoryService,
        suggestionsService: SuggestionsService
    ) {
        super(formBuilder, searchParamsFactory, suggestionsService);
    }

    public searchForKaryotypeSuggestions(value: string): void {
        const params = new SuggestionsSearchModel(ProductCollectionsEnum.CA, FieldAliases.CA_COLLECTION.KARYOTYPE, value);
        this.searchForSuggestions(params);
    }

    protected createFilterForm(): CaCollectionFilterForm {
        return CaCollectionFilterForm.createForm(this.formBuilder, this.filter, this.searchParamsFactory);
    }
}
